"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var Button = function (_super) {
  __extends(Button, _super);

  function Button() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Button.prototype.render = function () {
    if (this.props.disabled) {
      return this.renderDisabledButton();
    }

    return this.renderEnabledButton();
  };

  Button.prototype.renderDisabledButton = function () {
    return react_1.default.createElement(react_native_1.View, {
      style: [this.viewStyle, this.props.viewStyle]
    }, this.renderButtonLabel());
  };

  Button.prototype.renderEnabledButton = function () {
    var iconText = this.props.type === 'icon' ? this.props.iconText : undefined;
    return react_1.default.createElement(react_native_1.TouchableOpacity, {
      style: [this.viewStyle, this.props.viewStyle],
      onPress: this.props.onPress,
      accessibilityRole: "button",
      accessibilityLabel: iconText
    }, this.renderButtonLabel());
  };

  Button.prototype.renderButtonLabel = function () {
    return react_1.default.createElement(react_native_1.Text, {
      style: [this.textStyle, this.props.textStyle]
    }, this.props.label);
  };

  Object.defineProperty(Button.prototype, "viewStyle", {
    get: function get() {
      switch (this.props.type) {
        case 'icon':
          return theme_pricing_system_1.pricingStyles.buttonIconViewStyle;

        case 'secondary':
          return this.props.disabled ? theme_pricing_system_1.pricingStyles.buttonDisabledViewStyle : theme_pricing_system_1.pricingStyles.buttonSecondaryViewStyle;

        default:
          return this.props.disabled ? theme_pricing_system_1.pricingStyles.buttonDisabledViewStyle : theme_pricing_system_1.pricingStyles.buttonPrimaryViewStyle;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Button.prototype, "textStyle", {
    get: function get() {
      if (this.props.type !== 'icon') {
        return theme_pricing_system_1.pricingStyles.buttonTextStyle;
      }

      return this.props.disabled ? theme_pricing_system_1.pricingStyles.buttonDisabledIconTextStyle : theme_pricing_system_1.pricingStyles.buttonIconTextStyle;
    },
    enumerable: true,
    configurable: true
  });
  return Button;
}(react_1.default.Component);

exports.Button = Button;